import { Option, OptionValue } from '../../types';
import { UpdateOptionPayload } from '../OptionForm';

export const buildEnableOptionChoicePayload = (option: Option, optionChoice: OptionValue): UpdateOptionPayload => {
  const updatedOptionChoice: OptionValue = {
    ...optionChoice,
    enabled: {
      ...optionChoice.enabled,
      enabled: true,
    },
  };

  const { id, scope, version, ...baseOption } = option;

  return {
    ...baseOption,
    values: option.values.map(choice => (choice.id === optionChoice.id ? updatedOptionChoice : choice)),
  };
};

export const buildDisableOptionChoicePayload = (option: Option, optionChoice: OptionValue): UpdateOptionPayload => {
  const updatedOptionChoice: OptionValue = {
    ...optionChoice,
    enabled: {
      ...optionChoice.enabled,
      enabled: false,
    },
  };

  const { id, scope, version, ...baseOption } = option;

  return {
    ...baseOption,
    values: option.values.map(choice => (choice.id === optionChoice.id ? updatedOptionChoice : choice)),
  };
};
